const firebaseConfig = {
  apiKey: "AIzaSyATy8o4qLxBCoRo9dla1M34_u7HPMr6L_A",
  authDomain: "services-auth-42c42.firebaseapp.com",
  projectId: "services-auth-42c42",
  storageBucket: "services-auth-42c42.appspot.com",
  messagingSenderId: "804178636321",
  appId: "1:804178636321:web:27b52fc42c27c88133bd60"
};
  export default firebaseConfig;